import "../../scss/ApproachSection.scss";
import icon1 from "../../icons/approach-1.png";
import icon2 from "../../icons/approach-2.png";
import icon3 from "../../icons/approach-3.png";
import icon4 from "../../icons/writing.png";
import icon5 from "../../icons/approach-4.png";
import icon6 from "../../icons/approach-5.png";

export default function ApproachSection() {
  const items = [
    {
      id: 1,
      icon: icon1,
      title: "1. Анализ и стратегия",
      text: "Разбираемся в бизнесе, целях и позиционировании компании",
    },
    {
      id: 2,
      icon: icon2,
      title: "2. Концепция и стратегия",
      text: "Формируем структуру и вектор развития проекта",
    },
    {
      id: 3,
      icon: icon3,
      title: "3. Архитектура и структура контента",
      text: "Строим логику страниц, подбираем правильные акценты",
    },
    {
      id: 4,
      icon: icon4,
      title: "4. Дизайн и визуальная система",
      text: "Создаём качественный дизайн, который отражает суть компании",
    },
    {
      id: 5,
      icon: icon5,
      title: "5. Разработка и интеграции",
      text: "Реализуем задумку на самом актуально стеке технологий",
    },
    {
      id: 6,
      icon: icon6,
      title: "6. Тестирование и запуск",
      text: "Проверяем всё: производительность, адаптив, формы и скорость",
    },
  ];

  return (
    <section className="approach">
      <div className="approach__container">
        <h2 className="approach__title">НАШ ПОДХОД</h2>
        <p className="approach__text">
          Мы создаём корпоративные сайты, которые формируют у пользователей
          правильное восприятие компании, как надёжной, зрелой и современной.
          Погружаемся в суть бренда, разбираем, как он должен восприниматься, и
          строим структуру, дизайн и тексты так, чтобы это ощущение возникало
          естественно.
        </p>

        <div className="approach__grid">
          {items.map((item) => (
            <div className="approach__card" key={item.id}>
              <img src={item.icon} alt="" className="approach__icon" />
              <div className="approach__info">
                <h3 className="approach__card-title">{item.title}</h3>
                <p className="approach__card-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
